import React from "react";
import {Modal, List, Typography, Alert, Spin} from "antd";
import {formatMoney} from "../../../../../utils/moneyHelper";

const {Text} = Typography;

const WithdrawSummaryModal = ({
    visible,
    onCancel,
    onConfirm,
    loading,
    confirmLoading,
    summaryData,
    courierName
}) => {
    const renderItem = (item) => {
        const {label, amount, type, colorInfo} = item;

        if (type === "amount") {
            return (
                <List.Item>
                    <div style={{display: "flex", justifyContent: "space-between", width: "100%"}}>
                        <Text>{label}</Text>
                        <Text strong>{formatMoney({amount})}</Text>
                    </div>
                </List.Item>
            );
        }

        if (type === "info") {
            return (
                <List.Item>
                    <Text type="secondary">{label}</Text>
                </List.Item>
            );
        }

        if (type === "warning") {
            const alertType = colorInfo === "danger" ? "error" : "warning";
            return (
                <List.Item style={{padding: 0}}>
                    <Alert
                        message={label}
                        type={alertType}
                        showIcon
                        style={{width: "100%", marginBottom: 8}}
                    />
                </List.Item>
            );
        }

        return (
            <List.Item>
                <Text>{label}</Text>
            </List.Item>
        );
    };

    return (
        <Modal
            title={`Çekim Talebi Özeti - ${courierName}`}
            visible={visible}
            onCancel={onCancel}
            onOk={onConfirm}
            okText="Onayla"
            cancelText="İptal Et"
            confirmLoading={confirmLoading}
            width={600}
            okButtonProps={{disabled: loading || confirmLoading || !summaryData?.success}}
        >
            {loading ? (
                <div style={{textAlign: "center", padding: "40px 0"}}>
                    <Spin size="large" />
                    <div style={{marginTop: 16}}>
                        <Text>Özet hazırlanıyor...</Text>
                    </div>
                </div>
            ) : summaryData?.success ? (
                <List
                    dataSource={summaryData.items || []}
                    renderItem={renderItem}
                    style={{maxHeight: "400px", overflowY: "auto"}}
                />
            ) : (
                <Alert
                    message="Özet Yüklenemedi"
                    description="Para yatırma özeti yüklenirken bir hata oluştu."
                    type="error"
                    showIcon
                />
            )}
        </Modal>
    );
};

export default WithdrawSummaryModal; 